"use client";

import { useEffect, useState } from "react";
import Link from "next/link";
import { api, setAuth } from "@/lib/api";
import { AuthShell, inputStyle, btnStyle, labelStyle } from "@/components/AuthShell";

export default function RegisterPage() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [wechat, setWechat] = useState("");
  const [inviteCode, setInviteCode] = useState("");
  const [mode, setMode] = useState<"public" | "invite_only">("invite_only");
  const [trialDays, setTrialDays] = useState(3);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    if (code) setInviteCode(code);
    // 读取注册模式
    api<{ registration_mode: "public" | "invite_only"; trial_days?: number }>("/auth/registration-mode")
      .then((r) => {
        setMode(r.registration_mode);
        if (r.trial_days && r.trial_days > 0) setTrialDays(r.trial_days);
      })
      .catch(() => {});
  }, []);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setErr("");
    if (mode === "invite_only" && !inviteCode.trim()) {
      setErr("当前为邀请制注册，请填写邀请码");
      return;
    }
    setLoading(true);
    try {
      const res = await api<{ access_token: string; user: any }>("/auth/register", {
        method: "POST",
        body: JSON.stringify({
          username,
          password,
          wechat_nickname: wechat,
          invite_code: inviteCode.trim() || null,
        }),
      });
      setAuth(res.access_token, res.user);
      window.location.replace("/chat");
    } catch (e: any) {
      setErr(e.message || "注册失败");
    } finally {
      setLoading(false);
    }
  }

  if (!mounted) {
    return (
      <AuthShell
        title="注册"
        subtitle={`当前为邀请制，需要有效邀请码。注册后可试用 ${trialDays} 天`}
      />
    );
  }

  return (
    <AuthShell
      title="注册"
      subtitle={
        mode === "invite_only"
          ? `当前为邀请制，需要有效邀请码。注册后可试用 ${trialDays} 天`
          : `填写信息即可注册，注册后可试用 ${trialDays} 天`
      }
    >
      <form onSubmit={submit}>
        <label style={labelStyle}>用户名</label>
        <input
          style={inputStyle}
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          placeholder="2~64 个字符"
        />
        <label style={labelStyle}>密码</label>
        <input
          style={inputStyle}
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="至少 6 位"
        />
        <label style={labelStyle}>微信昵称（必填，方便我认出你）</label>
        <input
          style={inputStyle}
          value={wechat}
          onChange={(e) => setWechat(e.target.value)}
          placeholder="你的微信昵称"
        />
        <label style={labelStyle}>
          邀请码{mode === "invite_only" ? "（必填）" : "（可选）"}
        </label>
        <input
          style={inputStyle}
          value={inviteCode}
          onChange={(e) => setInviteCode(e.target.value)}
          placeholder={mode === "invite_only" ? "请输入邀请码" : "有邀请码可填"}
        />
        {err && (
          <div style={{ color: "#ff8a8a", fontSize: 13, marginBottom: 12 }}>{err}</div>
        )}
        <button style={btnStyle} disabled={loading}>
          {loading ? "注册中…" : "注册并开始"}
        </button>
      </form>
      <div style={{ marginTop: 16, fontSize: 14, color: "var(--muted)" }}>
        已有账号？{" "}
        <Link href="/login" style={{ color: "var(--accent)" }}>
          去登录
        </Link>
      </div>
    </AuthShell>
  );
}
